/**
 * Key Numbers 1036 — BDU Programme key features
 * Solid bar of circled-icon columns, each with one line of copy.
 */

export const KEY_NUMBERS_1036_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Key features",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_icon_alt: "",
    meta_description: "2 Years Duration",
    meta_priority: 1,
    meta_status: true,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Bar background",
      value: "#836537",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#836537",
    },
    {
      fieldName: "description_color",
      label: "Copy colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Icon circle fill",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_4",
      label: "Separator line (from 860px up)",
      value: "#FFFFFF66",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF66",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (36x36)",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "meta_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Copy",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Live & Recorded Lectures",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
